import React from 'react';
import { useAuth } from 'react-oidc-context';
import '@aurodesignsystem/auro-button';

interface CommonHeaderElementsProps {
  onSignOut?: () => void; // Optional callback for additional actions on sign out
  hideSignOut?: boolean; // If true, hides the sign out button (for use in AdminHeader)
}

const CommonHeaderElements: React.FC<CommonHeaderElementsProps> = ({ onSignOut, hideSignOut = false }) => {
  const auth = useAuth();

  const handleSignOut = () => {
    auth.removeUser();
    if (onSignOut) {
      onSignOut();
    }
  };

  return (
    <div className="header-elements-wrapper">
      {/* Logo, separator, and title wrapper */}
      <div className="header-content-left">
        <img
          className="header-logo"
          src="https://resource.alaskaair.net/-/media/A2B28D27C57B4BB9A72557221CF779A3"
          alt="Alaska Airlines"
          loading="eager"
        />
        
        <div className="header-separator" aria-hidden="true" />
        
        <div 
          className="header-title"
          style={{
            width: "165.423px",
            height: "28.243px",
            flexShrink: 0,
            color: "#099DC5",
            fontFamily: "'AS Circular', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            fontSize: "18px",
            fontWeight: 450
          }}
        >
          Flight Range
        </div>
      </div>

      {/* Sign Out Button - Only show if not hidden */}
      {!hideSignOut && (
        <div className="header-right">
          <auro-button
            ref={(el: any) => {
              if (el) {
                el.addEventListener('click', handleSignOut);
              }
            }}
            variant="secondary"
            size="sm"
            aria-label="Sign out of application"
            className="header-sign-out"
            responsive
            style={{
              borderRadius: "6px",
              background: "transparent",
              border: "1px solid var(--ui-default, #0074CA)",
              color: "var(--ui-default, #0074CA)"
            }}
          >
            Sign out
          </auro-button>
        </div>
      )}
    </div>
  );
};

export default CommonHeaderElements;
